// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__q34zo","inner":"Hero_inner__1L7SI"};